import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Injectable } from '@odinjs/odin';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { PatientHttpService } from '../services/patient-http-service';

export interface EmailSendResult {
  error?: boolean;
}

export interface RecoverPassword {
  emailID?: string;
}

export interface SmsSendResult {
  body: string,
  status: number
}

export interface RecoveryDataProps {
  dsLoginTemp?: string;
  email?: string;
  isLaboratoryWebUser?: boolean;
  patientId?: string;
  phoneNumber?: string;
}

interface ResetPasswordSmsResponse {
  username: string;
}

@Injectable({})
export default class ResetPasswordService {
  static recoverPassword(captchaResponse: string | null, identifier: string, validationType: string): Promise<RecoverPassword> {
    const body ={
      captchaResponse,
      identifier,
      validationType

    }
    return HttpService.post(APPLICATION_ENDPOINTS.EMAILSMSSENDER_RECOVEREMAILSMS, {}, {body}).then(response => response.status as RecoverPassword);
  }

  static recoverPasswordBySms(captchaResponse: string | null, identifier: string, validationType: string): Promise<SmsSendResult> {
    const body ={
      captchaResponse,
      identifier,
      validationType
    }
    return HttpService.post(APPLICATION_ENDPOINTS.EMAILSMSSENDER_RECOVEREMAILSMS, {},{body}).then(response => response as SmsSendResult);
  }

  static resendPasswordBySms(body: Record<string, Value>, dsLogin: string): Promise<SmsSendResult> {
    return HttpService.post(APPLICATION_ENDPOINTS.RESEND_REQUEST_PASSWORD_SMS, {dsLogin}, { body }).then(response => response as SmsSendResult);
  }

  static findUsernameRecoveryData(recoveryDocumentType: string, recoveryKey: string, type: string): Promise<RecoveryDataProps | undefined> {
    return PatientHttpService.post<RecoveryDataProps>(APPLICATION_ENDPOINTS.POST_RECOVERY_DATA, {}, { body: { recoveryDocumentType, recoveryKey, type } }).then(response => {
      return response.body
    });
  }

  static postResetPassword(body: Record<string, Value>): Promise<HttpResponse<ResetPasswordSmsResponse>> {
    return PatientHttpService.post(APPLICATION_ENDPOINTS.EMAILSMSSENDER_RECOVEREMAILSMS, {}, { body });
  }
}
